import * as React from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { ToastContainer } from 'react-toastify';
import OverlayLoader from '../../components/OverlayLoader';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import AuthTypes from './../../redux/constants';
import HttpClient from '../../helpers/HttpClient'; 

import Copyright from '../../components/Copyright';
import { showToast } from '../../utils/toast';
import { sha256Encode, base64Decode, base64Encode, md5Encode } from '../../utils/generals';
import {
  getMachineId,
  readSerialFiles,
  deleteSerialFiles,
  isInternetAvailable,
  axiosNativePost
} from '../../utils/electronFunctions';
import { userApi, tokenApi, BAD_REQUEST_ERRORS } from '../../constants';

export default function Activate() {
  const [open, setOpen] = React.useState(false);
  const [ready, setReady] = React.useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const authState = useSelector((state) => state.auth);
  const userId = authState.user ? authState.user.email : "test"

  const requestActivation = async (pin) => {
    setOpen(true);

    const registerCode = await HttpClient().post(`/pin/activate`, {
      pin: pin,
      userId: userId
    });
    setOpen(false);

    if (registerCode.error) {
      showToast(
        'No fue posible activar tu licencia. Revisa que tu pin sea válido e intenta nuevamente. Si el error persiste contacta al administrador.',
        'error'
      );
    } else {
      setReady(true);
      await deleteSerialFiles();
      showToast(
        'Aplicación activada correctamente',
        'success',
        undefined,
        () => {
          setOpen(false);
          navigate('/home');
        }
      );
    }
    
  };


  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    const pin = data.get('pin').trim();
    if (pin == '') {
      showToast('Digita un pin válido');
    } else {
      await requestActivation(pin);
    }
  };

  return (
    <Container component="main" maxWidth="xs">
      <OverlayLoader
        open={open}
        ready={ready}
        buttonClick={() => {
          setOpen(false);
          navigate('/login');
        }}
      />
      <CssBaseline />
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
          Activar aplicación
        </Typography>
        <Typography
          sx={{ marginTop: 2, marginBottom: 2 }}
          component="h1"
          variant="body2"
        >
          Digita el pin suministrado
        </Typography>
        <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
          <TextField
            margin="normal"
            required
            fullWidth
            id="pin"
            label="Pin de activación"
            name="pin"
            autoComplete="off"
            autoFocus
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
          >
            Activar
          </Button>

          <Grid container justifyContent="flex-end">
              <Grid item>
                <Link
                  component="button"
                  variant="body2"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate(-1);
                  }}
                >
                  Volver
                </Link>
              </Grid>
            </Grid>
        </Box>
      </Box>
      {/*<Copyright sx={{ mt: 8, mb: 4 }} />*/}
      {/*<ToastContainer />*/}
    </Container>
  );
}
